import { render, staticRenderFns } from "./DBKeyParameter.vue?vue&type=template&id=6f2fe38e&scoped=true&"
import script from "./DBKeyParameter.vue?vue&type=script&lang=js&"
export * from "./DBKeyParameter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2fe38e",
  null
  
)

export default component.exports